import styled from '@emotion/styled';

export const NoConversation = styled.p`
	text-align: center;
	font-size: 12px;
	padding: 20px 0;
	color: ${({ theme }) => theme.colors.grayLight};
`;

export const Loading = styled.div`
	overflow: hidden;

	.infiniteLoader {
		position: absolute;
		z-index: 10;

		height: 100%;
		width: 100%;

		display: flex;
		align-items: center;

		opacity: 1;
		background-image: linear-gradient(to top, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.7));
	}
`;
